module.exports = __webpack_public_path__ + "img/zhnc.b6308afa.png";